import React from 'react'

const changePassword = () => {
    return (
        <div>
            <h6>
                Change Password
            </h6>
        </div>
    )
}

export default changePassword
